import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted } from 'vue';

import { HelperViewStatus } from '@warrenbrasil/nebraska-web';
import { AboutStrategy } from './components/AboutStrategy';
import { TechnicalDetails } from './components/TechnicalDetails';
import { AboutLinks } from './components/AboutLinks';

import {
  getPortfolioAbout,
  PortfolioAboutData,
  PortfolioPaidEventConfiguration
} from '@/modules/wealth/services/portfolio';
import { PaidEventsConfigurationModal } from './components/PaidEvents/components/PaidEventsConfigurationModal';
interface Props {
  portfolioId: string;
  paidEventsConfiguration: PortfolioPaidEventConfiguration | undefined;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'About',
  props: {
    portfolioId: null,
    paidEventsConfiguration: null
  },
  setup(__props: any) {

const props = __props as {
  portfolioId: string;
  paidEventsConfiguration: PortfolioPaidEventConfiguration | undefined;
}



const isLoading = ref(true);
const hasError = ref(false);
const aboutData = ref<PortfolioAboutData | null>(null);
const isConfigurationModalOpen = ref(false);

const getAboutData = async () => {
  isLoading.value = true;
  hasError.value = false;
  try {
    const data = await getPortfolioAbout(props.portfolioId);

    aboutData.value = data.about;
  } catch {
    hasError.value = true;
  } finally {
    isLoading.value = false;
  }
};

const toogleConfigurationModal = () => {
  isConfigurationModalOpen.value = !isConfigurationModalOpen.value;
};

onMounted(async () => {
  await getAboutData();
});

return { __sfc: true,props, isLoading, hasError, aboutData, isConfigurationModalOpen, getAboutData, toogleConfigurationModal, HelperViewStatus, AboutStrategy, TechnicalDetails, AboutLinks, PaidEventsConfigurationModal }
}

})